import makeLookupModal from "../../UI/LookupModal/LookupModal";
import DegreeLookup from "./DegreeLookup";
const DegreeLookupModal = makeLookupModal(DegreeLookup, {
    pluralEntityName: "Degrees",
});
export default DegreeLookupModal;
